// extracted by mini-css-extract-plugin
export default {"cardSec":"CertificateActivityLogs_cardSec__kLlTa","certificateImgSec":"CertificateActivityLogs_certificateImgSec__LI1WS","downloadBtn":"CertificateActivityLogs_downloadBtn__aGsbJ"};